import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as theGlobals from '../shared/globals';

@Injectable()

export class StatsService {

    private myUrl = theGlobals.setEnv().funcUrl;

    constructor(private http: HttpClient) {
    }

    searchApplicationsByYear(year: any): Observable<any>
    {
      const xUrl = this.myUrl + '/stats/year/' + year;
      return this.http.get<any>(xUrl);
    }
    searchAppsByCaseYear(year: any): Observable<any>
    {
      const xUrl = this.myUrl + '/stats/caseyear/' + year;
      return this.http.get<any>(xUrl);
    }
    // find complex cases that need to be scheduled - used explicitly for the timer-related module(s)
    findComplexCasesForTimer(): Observable<any>
    {
      const xUrl = this.myUrl + '/stats/complex';
      return this.http.get<any>(xUrl);
    }
    getExpiringCasesCount(): Observable<any>
    {
      const xUrl = this.myUrl + '/stats/expiring/count';
      return this.http.get<any>(xUrl);

    }
    findAppsByComplexCase(specialCase: string = ""): Observable<any>
    {
      // if (!rollYear) { rollYear = new Date().getFullYear(); }
      let myParams = {
          ComplexCase: 1,
          SpecialCase: specialCase,
          RollYear: ""
      }
      const xUrl = this.myUrl + '/application/search/complexcase';
      return this.http.post(xUrl, myParams);
    }
    // fix missing date closed problem for applications in specified year
    fixDateClosed(year: any): Observable<any>
    {
      const xUrl = this.myUrl + '/sysops/fixdateclosed/' + year;
      return this.http.post(xUrl, year);
    }

}
